export default __webpack_public_path__ + "static/media/faq1.5b4cbd60.png";